import withProps from 'recompose/withProps';
import get from 'lodash/get';
import logger from 'src/logger';

// determine whether this is client or server
export const isServerSide = typeof window === 'undefined';
const win =  isServerSide ? {} : window;
const optimizely = () => get(win, 'optimizely.initialized', false) ? win.optimizely : {
  get(...args) {
    logger.info(['get', ...args]);
  },
  push(...args) {
    logger.info(['push', ...args]);
  },
};

const withOptimizely = withProps({
  optimizely,
});

export default withOptimizely;



// WEBPACK FOOTER //
// ./src/client/js/view/hocs/withOptimizely.js